// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"9a77b14d","483":"5911919f","526":"1a6ebb49","530":"0ea5b3c1","540":"3ecdbe98","787":"a8e6c4be","815":"a0d6ba31"}[chunkId] + ".chunk.js";
};